import { Wrapper } from 'shared/ui/Wrapper/Wrapper';
import { Title, TitleSize } from 'shared/ui/Title/Title';
import { Text, TextSize } from 'shared/ui/Text/Text';
import { useEffect, useState } from 'react';
import { Tabs } from 'shared/ui/Tabs';
import { TabsTheme } from 'shared/ui/Tabs/Tabs';
import { Selector } from 'shared/ui/Selector/Selector';
import { APIProductTypes, APIWalletHistory, APIWalletHistoryItem, ProductTypeName } from 'app/api/APITypes';
import { useApi } from 'app/api/APIProvider';
import { TransactionCards } from 'entities/TransactionCards';
import { TransactionCardsTheme } from 'entities/TransactionCards/TransactionCards';
import { formatNumber } from 'shared/lib/utils/utils';
import { AppLink } from 'shared/ui/AppLink/AppLink';
import { Button, ButtonTheme } from 'shared/ui/Button/Button';
import { Dropdown } from 'shared/ui/Dropdown/Dropdown';
import Logo from 'shared/assets/img/sber_logo.png';
import PlayIcon from 'shared/assets/icons/playIcon.svg';

import cls from './HistoryPage.module.scss';

export const HistoryPage = () => {
    const api = useApi();
    const [transactions, setTransactions] = useState<APIWalletHistory | null>(null);
    const [filter, setFilter] = useState<{
        type: 'income' | 'outcome' | 'moneybox',
        level: number/* 0 */,
        outcomeType: APIProductTypes | 'all'
    }>({ type: 'outcome', level: 0, outcomeType: 'all' });
    const [filteredResult, setFilteredResult] = useState<{ grouped: (APIWalletHistoryItem | APIWalletHistoryItem[])[], history: APIWalletHistoryItem[] }>({
        grouped: [],
        history: [],
    });

    const typeTabs: {name: string, value: typeof filter.type}[] = [{ name: 'Расходы', value: 'outcome' },
        { name: 'Доход', value: 'income' }];

    const levelTabs: {name: string, value: number}[] = [{ name: 'Общее', value: 0 },
        { name: 'Уровень 1', value: 1 }, { name: 'Уровень 2', value: 2 },
        { name: 'Уровень 3', value: 3 }, { name: 'Уровень 4', value: 4 }];

    const categoryTabsData = [
        {
            name: 'Все категории',
            value: 'all',
        },
        {
            name: 'Техника',
            value: 'tech',
        },
        {
            name: 'Еда',
            value: 'food',
        },
        {
            name: 'Аксессуары',
            value: 'accessories',
        },
        { 
            name: "Развлечения", 
            value: 'entertainment',
        },
        {
            name: 'Недвижимость',
            value: 'realty',
        },
        {
            name: "Спорт и отдых",
            value: 'sport',
        },
        {
            name: "Транспорт",
            value: 'transport',
        },
    ];

    const applyFilter = () => {
        const filteredResult = transactions?.history.filter((historyItem) => {
            if (filter.type === 'outcome' && historyItem.value < 0) {
                if (filter.level === 0 || filter.level === historyItem.level) {
                    if (filter.outcomeType === 'all' || filter.outcomeType === historyItem.product_category) {
                        return true;
                    }
                }
                return false;
            } if (filter.type === 'income' && historyItem.value > 0) {
                if (filter.level === 0 || filter.level === historyItem.level) {
                    return true;
                }
            }
            transactions.groupedHistory
            return false;
        }) ?? []

        // TODO This is bad. Refactor it
        let res: (APIWalletHistoryItem | APIWalletHistoryItem[])[] = [];
        if (transactions?.group_keys) {
            for (const group of transactions.group_keys) {
                for (let lvl = 1; lvl < 5; lvl++) {
                    const groupedByCategoryAndLevel = filteredResult.filter((value) => value.group === group && value.level === lvl);
                    if(groupedByCategoryAndLevel.length)
                        res = res.concat([groupedByCategoryAndLevel]);
                }
            }
            res = res.concat(filteredResult.filter((value) => value.group === null || !value.group.length));
        }

        return { grouped: res, history: filteredResult };
    };

    useEffect(() => {
        api.WalletHistory()
            .then(setTransactions.bind(this));
    }, []);

    useEffect(() => {
        setFilteredResult(applyFilter());
    }, [transactions, filter]);

    const updateFilterState = (value: 'income' | 'outcome' | 'moneybox' ) => setFilter((prevVal) => ({ ...prevVal, type: value }));
    const updateLevelState = (value: number ) => setFilter((prevVal) => ({ ...prevVal, level: value }));
    const updateCategoryState = (value: APIProductTypes | 'all' ) => setFilter((prevVal) => ({ ...prevVal, outcomeType: value }));

    return (
        <div className={cls.page}>
            <Wrapper className={cls.mainWrapper}>
                <main className={cls.main}>
                    <Text className={cls.title} color="#5A636B" size={TextSize.text_36}>История операций</Text>
                    <Text className={cls.subtitle} color="#5A636B" size={TextSize.text_16}>Анализ расходов и поступлений</Text>
                    <div className={cls.tabsWrapper}>
                        <div className={cls.tabs}>
                            <Tabs historyTabs={typeTabs} type={TabsTheme.V1} theme='history' cb={updateFilterState}/>
                        </div>
                        <div className={cls.levelSlector}>
                            <Selector options={levelTabs} callback={updateLevelState}/>
                        </div>
                        <div className={cls.categorySelector}>
                            <Selector options={categoryTabsData} callback={updateCategoryState}/>
                        </div>
                    </div>
                    <div className={cls.historyWrapper}>
                        <Text className={cls.transactionTitle} color="#5A636B" size={TextSize.text_36}>История</Text>
                        <div className={cls.transactionCardsWrapper}>
                            {
                                filteredResult.grouped.map((result, index) => {
                                    if (Array.isArray(result)) {
                                        const totalValue = result.map(({ value }) => value)
                                            .reduce((prevValue, currVal) => prevValue + currVal, 0);
                                        return <Dropdown transactions={result} totalValue={totalValue} key={index}/>
                                    } else {
                                        return <TransactionCards transaction={result} theme={TransactionCardsTheme.history} key={index} />
                                    }
                                })
                            }
                        </div>
                        <div className={cls.spendsWrapper}>
                            <Text className={`${cls.spendText} ${cls.outcomeText}`} color="#5A636B" size={TextSize.text_20_600}>
                                Итого сумма {filter.type === 'income' ? 'доходов' : 'расходов'}: {formatNumber(transactions?.history.map(v => v.value)
                                .filter((value) => {
                                    if (filter.type === 'income' && value > 0) {
                                        return value;
                                    } else if (filter.type === 'outcome' && value < 0) {
                                        return value;
                                    }
                                })
                                .reduce((prevVal, currVal) => prevVal + currVal, 0))} ₽
                            </Text>
                            <Text className={`${cls.spendText} ${cls.incomeText}`} color="#919191" size={TextSize.text_16}>
                                Итого сумма {filter.type === 'income' ? 'расходов' : 'доходов'}: {formatNumber(transactions?.history.map(v => v.value)
                                .filter((value) => {
                                    if (filter.type === 'outcome' && value > 0) {
                                        return value;
                                    } else if (filter.type === 'income' && value < 0) {
                                        return value;
                                    }
                                })
                                .reduce((prevVal, currVal) => prevVal + currVal, 0))} ₽
                            </Text>
                        </div>
                        <TransactionCards sum={transactions?.sum ?? ''} balanceText={"Ваш баланс"} theme={TransactionCardsTheme.sum} />
                    </div>
                </main>
                <AppLink to="/plot" className={cls.backToGameButton}>
                    <Button
                        theme={ButtonTheme.BACK_TO_GAME}
                        icon={<PlayIcon/>}
                        >
                        Продолжить сюжет
                    </Button>
                </AppLink>
                <img className={cls.logo} src={Logo} alt="" />
            </Wrapper>
        </div>
    );
};
